import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './layout/layout.component';
import { CanLoad, Route, Router } from '@angular/router';

import {AuthGuardService } from './providers/auth-guard-service'


// Page Layouts
import { PageLayoutFullscreenComponent } from './page-layouts/fullscreen/fullscreen.component';

const AppRoutes: Routes = [
  { path: '', redirectTo: '/extra/login', pathMatch: 'full' },
  // { path: 'app', component: LayoutComponent },
  { path: 'app', loadChildren:'./layout/layout.module#LayoutModule' },
  { path: 'extra', loadChildren: './extra-pages/extra-pages.module#ExtraPagesModule' },
  { path: 'fullscreen', component: PageLayoutFullscreenComponent },
  // { path: '**', redirectTo: '/app/dashboard', pathMatch: 'full' },
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, {useHash: true});



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/app-routing.module.ts